export const SourcetreeMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.8648 20.1091C38.8648 11.8991 32.2098 5.24414 23.9998 5.24414C15.7898 5.24414 9.13477 11.8991 9.13477 20.1091C9.13477 26.7151 13.4468 32.3071 19.4068 34.2431V41.6921C19.4068 42.2791 19.8828 42.7561 20.4708 42.7561H27.5278C28.1148 42.7561 28.5918 42.2801 28.5918 41.6921V34.2481C34.5528 32.3131 38.8648 26.7161 38.8648 20.1101V20.1091ZM23.9998 25.1341C21.2248 25.1341 18.9748 22.8841 18.9748 20.1091C18.9748 17.3341 21.2248 15.0841 23.9998 15.0841C26.7748 15.0841 29.0248 17.3341 29.0248 20.1091C29.0248 22.8841 26.7748 25.1341 23.9998 25.1341Z"
      fill="#0082FF"
    />
    <path
      d="M24 5.24414V15.0851C26.775 15.0851 29.025 17.3351 29.025 20.1101C29.025 22.8851 26.775 25.1351 24 25.1351C26.536 25.1351 28.592 27.1911 28.592 29.7271V34.2481C34.553 32.3131 38.865 26.7161 38.865 20.1101C38.865 11.9001 32.21 5.24514 24 5.24514V5.24414Z"
      fill="url(#paint0_linear_818_472)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_472"
        x1="31.432"
        y1="31.5641"
        x2="31.432"
        y2="15.7691"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0050D3" />
        <stop offset="1" stopColor="#0082FF" />
      </linearGradient>
    </defs>
  </svg>
);
